<!-- Inner wrapper matches reference monolithic employee template so global .rewards-tab styles apply correctly -->
<div class="rewards-tab">
<!-- Reward Earning Criteria Section -->
<div class="reward-criteria-section">
  <div class="reward-criteria-card">
    <div class="criteria-image">
      <img src="assets/images/rewards.png" alt="Rewards" width="80" height="80">
    </div>
    <div class="criteria-content">
      <h3 class="criteria-title">Reward Earning Criteria</h3>
      <div class="criteria-list">
        <span class="criteria-text" *ngIf="rewardSettings">
          ${{ rewardSettings.membership_reward }} per membership sold
        </span>
        <span class="criteria-text" *ngIf="!rewardSettings && !isLoadingRewardSettings">
          $10 per membership sold
        </span>
        <div class="criteria-separator" *ngIf="rewardSettings || (!rewardSettings && !isLoadingRewardSettings)"></div>
        <span class="criteria-text" *ngIf="rewardSettings">
          ${{ rewardSettings.threshold_reward }} for every {{ rewardSettings.wash_count }} memberships sold
        </span>
        <span class="criteria-text" *ngIf="!rewardSettings && !isLoadingRewardSettings">
          $50 for every 50 memberships sold
        </span>
        <span class="criteria-text" *ngIf="isLoadingRewardSettings">Loading...</span>
      </div>
      <app-add-button
        class="mobile-reward-button"
        buttonText="Reward Settings"
        variant="secondary"
        iconType="reward-settings"
        (buttonClick)="onRewardSettings()">
      </app-add-button>
    </div>
    <app-add-button
      buttonText="Reward Settings"
      variant="secondary"
      iconType="reward-settings"
      (buttonClick)="onRewardSettings()">
    </app-add-button>
  </div>
</div>

<!-- Search and Filter Section -->
<div class="search-filter-section">
  <app-searchbar
    placeholder="Search employees by name or employee ID"
    [(searchTerm)]="rewardsSearchTerm"
    (searchChange)="onRewardsSearchChange($event)"
    iconSize="small">
  </app-searchbar>
  <div class="filter-container">
    <div class="period-section">
      <span class="period-label">Period</span>
      <div class="period-dropdown-wrapper">
        <button class="dropdown-button" (click)="toggleRewardDateRangePicker(); $event.stopPropagation()">
          <span>{{ selectedRewardPeriod }}</span>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
               [class.rotated]="isRewardDateRangePickerOpen">
            <path d="M5.28 7.38L10 12.1L14.72 7.38" stroke="#15172E" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <app-date-range-picker
          [isOpen]="isRewardDateRangePickerOpen"
          [selectedPeriod]="selectedRewardPeriod"
          [customDateRange]="rewardCustomDateRange"
          [periodOptions]="rewardPeriodOptions"
          (periodChange)="onRewardDateRangePeriodChange($event)"
          (customDateRangeChange)="onRewardCustomDateRangeChange($event)"
          (close)="closeRewardDateRangePicker()"
          (apply)="onRewardDateRangeApply($event)">
        </app-date-range-picker>
      </div>
    </div>
  </div>
</div>

<!-- Shimmer Loading -->
<div *ngIf="loadingRewards" class="table-section">
  <app-loading-table-shimmer [columns]="shimmerColumns" [rows]="5"></app-loading-table-shimmer>
</div>

<!-- Rewards Table -->
<div class="table-section" *ngIf="!loadingRewards && filteredRewards.length > 0">
  <div class="table-container">
    <div class="table-scroll-wrapper" #rewardsTableScrollWrapper>
      <table class="rewards-table">
        <thead>
          <tr>
            <th>Employee</th>
            <th>Total Rewards Earned</th>
            <th>Membership Rewards</th>
            <th>Membership Threshold Rewards</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let reward of paginatedRewards; trackBy: trackByRewardId; let i = index"
              class="reward-row"
              [style.animation-delay]="(i * 0.05) + 's'"
              [attr.data-index]="i">
            <td>
              <div class="employee-info">
                <div class="employee-avatar">
                  <img *ngIf="reward.picture_url" [src]="reward.picture_url" [alt]="reward.employee_name" class="avatar-image">
                  <span *ngIf="!reward.picture_url" class="avatar-initials">{{ getEmployeeInitialsForReward(reward.employee_name) }}</span>
                </div>
                <div class="employee-details">
                  <div class="employee-name">{{ reward.employee_name }}</div>
                  <div class="employee-id" *ngIf="reward.employee_code">{{ reward.employee_code }}</div>
                  <div class="employee-id" *ngIf="!reward.employee_code && reward.emp_id">{{ reward.emp_id }}</div>
                  <div class="employee-id" *ngIf="!reward.employee_code && !reward.emp_id">{{ reward.employee_id }}</div>
                </div>
              </div>
            </td>
            <td><div class="reward-amount total-reward">{{ formatCurrency(reward.total_reward) }}</div></td>
            <td><div class="reward-amount membership-reward">{{ formatCurrency(reward.membership_reward) }}</div></td>
            <td><div class="reward-amount single-wash-reward">{{ formatCurrency(reward.membership_threshold_reward) }}</div></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Empty State -->
<div *ngIf="!loadingRewards && filteredRewards.length === 0" class="empty-state-container">
  <app-empty-result
    image="/assets/images/empty_screen.png"
    [title]="rewardsSearchTerm ? 'No rewards found' : 'No rewards to show!'"
    [description]="rewardsSearchTerm ? 'Try adjusting your search criteria' : 'No rewards data available.'"
    [showAction]="false">
  </app-empty-result>
</div>

<!-- Pagination -->
<div class="pagination-wrapper" *ngIf="filteredRewards.length > 0">
  <app-pagination-bar
    [paginationData]="paginationData"
    (pageChange)="onPageChange($event)"
    (itemsPerPageChange)="onItemsPerPageChange($event)">
  </app-pagination-bar>
</div>
</div>

<!-- Reward Settings Modal (outside .rewards-tab flex column — matches reference layout) -->
<app-reward-settings-modal
  [isOpen]="showRewardSettingsModal"
  [initialData]="rewardSettings"
  (closeModal)="onCloseRewardSettingsModal()"
  (saveSettings)="onSaveRewardSettings($event)">
</app-reward-settings-modal>
